import { Component, model, input, inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineItemModel } from '../../../../models/template.model';
import { SpeechService } from '../../../../services/speech.service';
import { ValidationService } from '../../../../services/validation.service';

@Component({
  selector: 'app-judgement-control',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="checklist-control-row">
      <label class="checklist-control-label">
        {{ lineItem().name }}@if (lineItem().isRequired) { <span class="required-indicator">*</span>}
      </label>
      <div class="checklist-control-input">
        <div class="judgement-panel" [class.judgement-panel--error]="hasError()">
          <button type="button" class="judgement-btn judgement-btn--success"
            [class.judgement-btn--selected]="value() === 1"
            [disabled]="disabled()"
            (click)="select(1)"
            aria-label="Success">
            <i class="ri-check-line"></i>
          </button>
          <button type="button" class="judgement-btn judgement-btn--neutral"
            [class.judgement-btn--selected]="value() === 0"
            [disabled]="disabled()"
            (click)="select(0)"
            aria-label="Neutral">
            <i class="ri-subtract-line"></i>
          </button>
          <button type="button" class="judgement-btn judgement-btn--cancel"
            [class.judgement-btn--selected]="value() === -1"
            [disabled]="disabled()"
            (click)="select(-1)"
            aria-label="Cancel">
            <i class="ri-close-line"></i>
          </button>
        </div>
        @if (hasError()) {
          @for (err of errors(); track $index) {
            <small class="p-error d-block">{{ err }}</small>
          }
        }
      </div>
      <div class="ctrl-speaker-col">
        <button type="button" class="ctrl-speaker-btn" (click)="speakLabel()"
          [attr.aria-label]="'Read label: ' + lineItem().name">
          <i class="ri-volume-up-line"></i>
        </button>
      </div>
    </div>
  `,
  styles: [`
    .judgement-panel--error {
      border: 1px solid #ef4444;
      border-radius: 6px;
      padding: 0.25rem;
      background: #fef2f2;
    }
  `]
})
export class JudgementControlComponent {
  lineItem = input.required<LineItemModel>();
  value = model<number | null>(null);
  disabled = input<boolean>(false);
  showError = input<boolean>(false);

  private speechService = inject(SpeechService);
  private validationService = inject(ValidationService);
  touched = signal(false);

  errors = computed(() => {
    if (!this.showError() && !this.touched()) return [];
    return this.validationService.validate(this.lineItem(), this.value());
  });

  hasError = computed(() => this.errors().length > 0);

  select(val: number): void {
    // Toggle off if clicking the already-selected value
    this.value.set(this.value() === val ? null : val);
    this.touched.set(true);
  }

  speakLabel(): void {
    this.speechService.speak(this.lineItem().name);
  }
}
